import Vue from 'vue';
import Router from 'vue-router';

import guestRoutes from './guest';
import userRoutes from './user';

import PageNotFound from '../views/PageNotFound.vue';

Vue.use(Router);

export default new Router({
  routes: [
    ...guestRoutes,
    ...userRoutes,
    { path: '*', component: PageNotFound },
  ],
  // routes: [
  //   {
  //     path: '/',
  //     name: 'home',
  //     component: Home,
  //   },
  //   {
  //     path: '/about',
  //     name: 'about',
  //     // route level code-splitting
  //     // this generates a separate chunk (about.[hash].js) for this route
  //     // which is lazy-loaded when the route is visited.
  //     component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
  //   },
  // ],
});
